if (!customElements.get('termin-pill-picker')) {
  customElements.define(
    'termin-pill-picker',
    class TerminPillPicker extends HTMLElement {
      constructor() {
        super();
        this.pageSize = parseInt(this.dataset.pageSize, 10) || 6;
        this.visibleCount = this.pageSize;
        this.button = this.querySelector('.termin-pill-load-more');

        if (this.button) {
          this.button.addEventListener('click', this.showMore.bind(this));
        }
      }

      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.variant-pill-item'));
        this.update();
      }

      update() {
        this.items.forEach((item, index) => {
          item.style.display = index < this.visibleCount ? '' : 'none';
        });

        if (this.button) {
          this.button.hidden = this.visibleCount >= this.items.length;
        }
      }

      showMore() {
        this.visibleCount += this.pageSize;
        this.update();
      }
    }
  );
}
